import { io } from "socket.io-client";
import { config } from "./config";

let socket = null;

export function getSocket() {
  if (socket) return socket;

const origin = window.location.origin.trim(); // .trim() enlève les espaces
const targetUrl = (config.apiBase && !config.apiBase.includes('localhost'))
  ? config.apiBase.trim()
  : origin;

socket = io(targetUrl, {
  auth: { tenantId: config.tenantId, userId: config.userId, role: "user" },
  transports: ["websocket"],
});

  return socket;
}
